import styles from './CommunicationsSection.module.scss';

const directions = [
  {
    title: 'Электричество',
    text: 'На каждый участок предусмотрена мощность 15 кВт. Электрическая линия проходит по границе участка.',
  },
  {
    title: 'Вода и канализация',
    text: 'Центральные сети водоснабжения и водоотведения заведены непосредственно на участок.',
  },
  {
    title: 'Газ',
    text: 'Газовая сеть заведена на участок.',
  },
  {
    title: 'Интернет',
    text: 'Линия интернета проходит по границе участка. Для подключения собственнику достаточно обратиться к провайдеру.',
  },
] as const;

export function CommunicationsSection() {
  return (
    <section className={styles.section} id="communications" aria-labelledby="communications-title">
      <header className={styles.header} data-reveal>
        <div className={styles.heading}>
          <p className={styles.eyebrow}>Инженерная инфраструктура</p>
          <h2 id="communications-title">Коммуникации уже функционируют</h2>
        </div>
        <p className={styles.lead}>
          Все основные коммуникации в Лучезарной Долине уже построены, подведены к участкам и функционируют.
          Вам не нужно ждать строительства сетей или организовывать автономные
          системы для будущего дома.
        </p>
      </header>

      <ol className={styles.directions}>
        {directions.map((direction, index) => (
          <li
            key={direction.title}
            data-reveal
            data-reveal-delay={index > 0 ? String(Math.min(index, 2)) : undefined}
          >
            <span>{String(index + 1).padStart(2, '0')}</span>
            <h3>{direction.title}</h3>
            <p>{direction.text}</p>
          </li>
        ))}
      </ol>

      {/* <p className={styles.note} data-reveal>
        Отдельная плата за предоставление возможности подключения к внутрипоселковым сетям не
        взимается. Расположение точек подключения уточняется для каждого выбранного участка.
      </p> */}
    </section>
  );
}
